import script from "./LoadProjectsMixin.vue?vue&type=script&lang=js"
export * from "./LoadProjectsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__